{
  "valid": "Valide",
  "expired": "Certificat expiré",
  "month": "{n} mois | {n} mois",
  "days": "{n} jour restant | {n} jours restants",
  "keystore": {
    "generateSelfSignedCertificate": "Générer un certificat auto-signé",
    "generateCSR": "Générer un CSR",
    "csrRequiresUploadCertificate": "Cette demande de signature de certificat nécessite l’ajout d’un certificat",
    "list": {
      "action": {
        "delete": {
          "description": "Le certificat {alias} va être supprimé."
        }
      }
    },
    "updateCertificate": "Mettre à jour le certificat",
    "csr": "CSR",
    "certificate": "Certificat",
    "error": {
      "csr": {
        "loading": "Échec du chargement du CSR."
      }
    },
    "automaticRenewal": {
      "label": "Renouvellement automatique du certificat",
      "csr": {
        "info": "Le renouvellement automatique s’exécutera chaque jour si une configuration PKI est associée à ce certificat. Vous pouvez également déclencher le renouvellement immédiatement en appuyant sur le bouton.",
        "buttonLabel": "Générer le certificat"
      }
    },
    "filters": {
      "searchByAlias": "Rechercher par alias"
    }
  },
  "download": "Télécharger le certificat",
  "delete": "Supprimer certificat",
  "noCertificate": "Aucun certificat n’est disponible",
  "tag": "Étiquette",
  "tags": {
    "label": "Étiquettes",
    "empty": "Aucune étiquette trouvée"
  },
  "alias": "Alias",
  "expiration": {
    "timestamp": {
      "label": "Date d’expiration",
      "labelColon": "Date d’expiration :"
    }
  },
  "list": {
    "column": {
      "timestamp": {
        "format": "DD/MM/YYYY à HH:mm"
      }
    },
    "action": {
      "delete": {
        "description": "Le certificat {alias} va être supprimé."
      }
    }
  },
  "form": {
    "serialNumber": "Numéro de série",
    "organizationUnit": "Unité d'organisation",
    "organization": "Organisation",
    "locality": "Localité",
    "region": "Région",
    "country": "Pays",
    "tags": {
      "placeholder": "Sélectionner",
      "remove": {
        "tooltip": "Cliquer pour retirer le tag"
      }
    },
    "associatedPkiConfiguration": "Configuration PKI associée",
    "cn": "CN",
    "email": "Email"
  },
  "validation": {
    "alias": {
      "required": "L’alias est obligatoire.",
      "invalid": "L’alias ne doit contenir que des lettres minuscules de l’alphabet latin, des chiffres des tirets, des tirets bas ou des espaces."
    },
    "cn": "Le CN est obligatoire.",
    "email": "L’email est obligatoire.",
    "certificate": {
      "invalid": "Le certificat ne semble pas être valide.",
      "extension": "Le certificat ne contient pas la bonne extension.",
      "fileEmpty": "Le fichier ne doit pas être vide.",
      "fileSize": "La taille du fichier ne doit pas dépasser 750 Mo."
    },
    "associatedPkiConfiguration": "Avertissement : Le renouvellement automatique du certificat ne pourra pas s’effectuer tant que le certificat/CSR ne sera pas associé à une configuration PKI."
  },
  "error": {
    "certificate": {
      "loading": "Échec du chargement du certificat."
    }
  },
  "truststore": {
    "uploadCertificate": "Ajouter le certificat",
    "editCertificate": "Modifier le certificat"
  },
  "filters": {
    "searchByAlias": "Rechercher par alias"
  },
  "cancelAction": {
    "confirm": {
      "message": "Êtes-vous sûr de vouloir annuler cette opération ? Toutes les données seront perdues."
    }
  },
  "chain": {
    "label": "Chaîne de certificats",
    "level": "niveau {level}"
  },
  "downloadCSR": "Télécharger le CSR",
  "subject": {
    "label": "Nom"
  },
  "subjectAlternativeName": {
    "label": "Noms alternatifs",
    "add": "Ajouter un nom alternatif",
    "empty": "Il n'y a pas de noms définis.",
    "delete": "Supprimer le SAN",
    "noValue": "Valeur manquante",
    "unknownError": "Une erreur inconnue a eu lieu lors de la vérification",
    "type": "Type",
    "value": "Valeur",
    "2": {
      "label": "DNS",
      "labelColon": "DNS :",
      "invalidFormat": "La valeur doit être un DNS valide"
    },
    "7": {
      "label": "IP",
      "labelColon": "IP :",
      "invalidFormat": "La valeur doit être une adresse IP valide"
    }
  },
  "extendedKeyUsage": {
    "label": "Utilisation étendue des clés",
    "empty": "Il n'y a pas de clés définies.",
    "1": "Authentification serveur",
    "2": "Authentification client"
  },
  "tab": {
    "keystore": "Keystore",
    "truststore": "Truststore"
  },
  "trustChain": {
    "label": "Chaîne de certificats"
  },
  "start": {
    "timestamp": {
      "labelColon": "Date de début de validité :"
    }
  }
}
